<template lang="pug">
//- :lazy-src="require(`@/assets/ui-icons/${name}.svg`)"
//- Создаёт некрасивую анимацию появления
v-img.icon-template(
  :src="require(`@/assets/ui-icons/${name}.svg`)"
  :alt="name"
  @load="setMask"
)
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    /** @TRASHFIX: Жуткий костыль, чтобы цвет ставить иконке,
     *  исправьте, пожалуйста, если будут идеи.
     *  Пытался через переменные scss, css, но не получилось.
     */
    setMask() {
      import(`@/assets/ui-icons/${this.name}.svg`).then((module) => {
        const url = module?.default || null;
        if (url && this.$el) {
          const icon = [...this.$el?.children || []].find((item) =>
            (item?.className || '').includes('v-image__image')
            && !(item?.className || '').includes('v-image__image--preload'));
          if (icon?.style) {
            icon.style.maskImage = icon.style.backgroundImage;
            icon.style.backgroundColor = 'currentColor';
            icon.style.backgroundImage = 'unset';
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-template {
  fill: currentColor;
  color: unset !important;
  overflow: inherit;

  &:deep(> .v-image__image) {
    color: currentColor;
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position: center;
  }
}
</style>
